module.exports = "<i \n  class=\"fas fa-spinner fa-spin\"\n  [style.font-size]=\"fontSize\"\n></i>\n"